import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionsRoutingModule } from './questions-routing.module';
import { QuestionStatisticComponent } from './questions-statistic/questions-statistic.component';
import { CouncilMemberStatisticComponent } from './questions-statistic/council-member-statistic/council-member-statistic.component';
import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { QuestionStatisticChart } from './questions-statistic/question-statistic-chart/question-statistic-chart.component';
import { OrganizationalUnitQuestionsStatistic } from './questions-statistic/organizational-unit-questions-statistic/organizational-unit-questions-statistic.component';

@NgModule({
    declarations: [QuestionStatisticComponent, CouncilMemberStatisticComponent, OrganizationalUnitQuestionsStatistic, QuestionStatisticChart],
  imports: [
      CommonModule,
      CoreModule,
      SharedModule,
      QuestionsRoutingModule
  ]
})
export class QuestionsModule { }
